export default {
    getUserDetailList(state)
    {
        return state.UserDetailList;
    },
    getUserSession(state)
    {
        return state.UserSession;
    },
    getUserApplicationList(state)
    {
        return state.UserApplicationList;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    isAuthorized(state) {
        return state.isAuthorized;
    },
    didAutoLogout(state) {
        return state.didAutoLogout;
    },
    isWaitingSmsTokenValidation(state) {
        return state.waitingSmsToken;
    },
    getOnline(state){
        return !!state.isOnline;
    },
    showSessionExpiredModal(state) {
        return state.showSessionExpiredModal;
    }
}